module.exports = __webpack_public_path__ + "static/img/img6.246cf77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img6.png
// module id = PueB
// module chunks = 1